import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';

import styles from './privacy-policy-page.module.scss';

interface PrivacyPolicyPageProps {
  contentHtml: string | null;
  hostedDocumentUrl?: string;
}

const PrivacyPolicyPage = ({ contentHtml, hostedDocumentUrl }: PrivacyPolicyPageProps) => {
  return (
    <>
      <Breadcrumbs lastElementTitle="Privacy Policy" />
      <section className={styles.privacyPolicyPage}>
        <div className={styles.privacyPolicyPage__container}>
          <h1 className={styles.privacyPolicyPage__title}>Privacy Policy</h1>

          <div className={styles.privacyPolicyPage__card}>
            {contentHtml ? (
              <div className={styles.privacyPolicyPage__content} dangerouslySetInnerHTML={{ __html: contentHtml }} />
            ) : (
              <div className={styles.privacyPolicyPage__unavailable}>
                <h2 className={styles.privacyPolicyPage__unavailable__title}>Document temporarily unavailable</h2>
                <p className={styles.privacyPolicyPage__unavailable__text}>
                  We could not load the latest Privacy Policy from iubenda right now. Please try again in a few minutes
                  or open the hosted version.
                </p>
                <a
                  className={styles.privacyPolicyPage__unavailable__link}
                  href={hostedDocumentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open the hosted Privacy Policy
                </a>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicyPage;
